import { useMemo } from 'react'

import { TrackingV2Service } from '@api'
import { useUnit } from 'effector-react'
import type { DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'
import { dateToString } from '@/utils/helpers.ts'

export const useChatterTrackingData = (dateRange?: DateRange) => {
  const creatorId = useUnit($creatorId)

  const { data, isFetching, refetch } = useQuery(
    ['tracking', dateRange, creatorId],
    async () => {
      return TrackingV2Service.findTrackingDataByCreator({
        creatorId: creatorId!,
        from: dateToString(dateRange?.from || new Date()),
        to: dateToString(dateRange?.to || new Date()),
      })
    },
    {
      enabled: !!creatorId && !!dateRange,
      onError: (error) =>
        handleError(error, 'Failed to get chatter tracking data', refetch),
    },
  )

  return useMemo(
    () => ({
      data,
      isFetching,
      refetch,
    }),
    [data, isFetching, refetch],
  )
}
